import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import SuccessImage from "assets/images/success.png";

export default function Success() {
  const isDesktop = useTwBreakpoint("lg");

  const Close = isDesktop ? DialogClose : DrawerClose;
  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  return (
    <>
      <Header
        title="Your subscription has been updated!"
        subtitle="Subscription updated successfully. You can always review your current subscription in your Workspace settings"
        imgSrc={SuccessImage}
      />

      <Footer className="justify-end">
        <Close asChild>
          <Button variant="secondary-black" size={isDesktop ? "md" : "lg"}>
            Continue
          </Button>
        </Close>
      </Footer>
    </>
  );
}
